export default __webpack_public_path__ + "static/media/craon18.95c97fa4.jpg";